module.exports = {
  DEFAULT_PROJECTION: 'mercator',
  DEFAULT_STYLE: 'TRANSPORTATION',
  DEFAULT_DARK_FEATURE_COLOR: '#555',
  DEFAULT_LIGHT_FEATURE_COLOR: '#e8e8e8',
  DEFAULT_SATELLITE_FEATURE_COLOR: '#00f900',
  DEFAULT_3D_BUILDINGS: true,
  // Trimble Maps API Key - Replace with your actual API key
  TRIMBLE_API_KEY: '732AB39C689A304C860E36B82104842B'
};
